var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#45728B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 2.6665C8.36755 2.6665 8.66602 2.96498 8.66602 3.33317V7.33317H12.666C13.0342 7.33317 13.3327 7.63164 13.3327 7.99984C13.3327 8.36804 13.0342 8.6665 12.666 8.6665H8.66602V12.6665C8.66602 13.0347 8.36755 13.3332 7.99935 13.3332C7.63115 13.3332 7.33268 13.0347 7.33268 12.6665V8.6665H3.33268C2.9645 8.6665 2.66602 8.36804 2.66602 7.99984C2.66602 7.63164 2.9645 7.33317 3.33268 7.33317H7.33268V3.33317C7.33268 2.96498 7.63115 2.6665 7.99935 2.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.e60a9a723c423b993747da8cacf1fd8c.svg";
export { ForwardRef as ReactComponent };